export default __webpack_public_path__ + "static/shipping-policy-min-037a12387dfe5a6d40b010d5303b9a83.jpeg";